import React from "react";
import classNames from "classnames";
import { omit } from "lodash";
import { Tooltip } from "@blueprintjs/core";
import Loader from "components/Loader";
import * as styles from "./styles.module.scss";
export var ButtonStyle;
(function (ButtonStyle) {
    ButtonStyle["Primary"] = "primary";
    ButtonStyle["Secondary"] = "secondary";
    ButtonStyle["Tertiary"] = "tertiary";
    ButtonStyle["Link"] = "link";
})(ButtonStyle || (ButtonStyle = {}));
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["Normal"] = "normal";
    ButtonSize["Big"] = "big";
    ButtonSize["Small"] = "small";
    ButtonSize["ExtraSmall"] = "extraSmall";
})(ButtonSize || (ButtonSize = {}));
const Button = ({ label, title, progress = false, style = ButtonStyle.Primary, size = ButtonSize.Normal, tabIndex, submit = false, disabled = false, square = false, inverted = false, role = "button", testId, classes = {}, showTooltipIfDisabled, position, onClick, onDoubleClick, onBlur, onKeyDown, isMinMax = false, }) => (React.createElement(Tooltip, { key: title, content: title, minimal: true, openOnTargetFocus: false, placement: position || "left", disabled: (disabled && !showTooltipIfDisabled) || !title, renderTarget: (props) => {
        const { ...restProps } = props;
        return (React.createElement("button", { ...omit(restProps, "isOpen"), type: submit ? "submit" : "button", role: role, className: classNames(styles.button, classes.root, styles[size], styles[style], {
                [styles.minMax]: isMinMax,
                [styles.square]: square,
                [styles.inverted]: inverted,
                [styles.disabled]: disabled,
            }), onClick: (e) => {
                onClick && !disabled && onClick(e);
                restProps.onClick && restProps.onClick(e);
            }, onDoubleClick: (e) => {
                onDoubleClick && !disabled && onDoubleClick(e);
                restProps.onDoubleClick && restProps.onDoubleClick(e);
            }, onKeyDown: (e) => {
                onKeyDown && !disabled && onKeyDown(e);
                restProps.onKeyDown && restProps.onKeyDown(e);
            }, onBlur: (e) => {
                onBlur && !disabled && onBlur(e);
                restProps.onBlur && restProps.onBlur(e);
            }, tabIndex: tabIndex ?? restProps.tabIndex, "data-testid": testId },
            React.createElement("span", { className: classNames(styles.labelContainer, classes?.labelContainer) },
                progress && (React.createElement("span", { className: styles.loader },
                    React.createElement(Loader, { size: 16 }))),
                label)));
    }, portalClassName: classNames(classes.portal, styles.tooltipPortal), popoverClassName: classNames(styles.tooltip, classes.popover) }));
export default Button;
